
import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const AddItemModal = ({ isOpen, onClose, onSave, title, fields }) => {
    const [state, setState] = useState({});

    useEffect(() => {
        // Only reset state when modal opens, not on every fields change
        if (isOpen) {
            const initialState = fields.reduce((acc, field) => {
                if (field.type === 'select' && field.options && field.options.length > 0) {
                    acc[field.id] = field.options[0];
                } else {
                    acc[field.id] = '';
                }
                return acc;
            }, {});
            setState(initialState);
        } else {
            // Reset state when modal closes
            setState({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]); // Only depend on isOpen - fields are stable and we want current value when modal opens

    const handleSave = async () => {
        if (fields.length > 0 && state[fields[0].id] && String(state[fields[0].id]).trim()) {
            // Call onSave and wait for it to complete (it might be async)
            const result = onSave(state);
            // If onSave returns a promise, wait for it
            if (result && typeof result.then === 'function') {
                try {
                    await result;
                } catch (error) {
                    // If save fails, don't close modal so user can fix errors
                    console.error('Error saving:', error);
                    return;
                }
            }
            // Close modal after successful save
            onClose();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className="space-y-4">
                {fields.map(field => (
                    <div key={field.id}>
                        <label className="block text-sm font-medium mb-1">{field.name}</label>
                        {field.type === 'select' ? (
                            <select
                                value={state[field.id] || ''}
                                onChange={(e) => setState(prev => ({ ...prev, [field.id]: e.target.value }))}
                                className="w-full px-3 py-2 border rounded-lg"
                            >
                                <option value="">Select {field.name}</option>
                                {field.options?.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type={field.type || "text"}
                                value={state[field.id] || ''}
                                onChange={(e) => {
                                    setState(prev => ({ ...prev, [field.id]: e.target.value }));
                                }}
                                onKeyDown={(e) => {
                                    // Prevent modal from closing on Enter key
                                    if (e.key === 'Enter' && fields.length === 1) {
                                        e.preventDefault();
                                        handleSave();
                                    }
                                }}
                                className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                placeholder={`Enter ${field.name}`}
                                autoFocus={field.id === fields[0]?.id}
                            />
                        )}
                    </div>
                ))}
                <div className="flex justify-end gap-3 pt-2">
                    <button onClick={onClose} className="px-4 py-2 text-sm rounded-lg">Cancel</button>
                    <button onClick={handleSave} className="px-4 py-2 text-sm text-white bg-blue-600 rounded-lg shadow">Save</button>
                </div>
            </div>
        </Modal>
    );
};

export default AddItemModal;
